import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ハッシュ付きURLでページに来たとき、
 * 1. 描画前にスクロール位置をトップ(0)へ即リセット → フッターのチラ見えを防止
 * 2. その後トップから目的のアンカー要素へスムーズにスクロール（上から下への自然な動き）
 *
 * ハッシュが無い場合は通常どおりトップ表示。
 */
export function useHashScroll() {
  const { hash } = useLocation();

  // ブラウザのスクロール位置復元を無効化（前回位置の復元による違和感を防ぐ）
  if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
  }

  // useLayoutEffect: ブラウザ描画前に同期実行されるため、
  // フッターが一瞬見えることを確実に防げる
  useLayoutEffect(() => {
    // まず必ずトップへ即座にリセット（アニメーション無し）
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });

    if (!hash) return;

    const id = hash.replace("#", "");

    const scrollToTarget = () => {
      const element = document.getElementById(id);
      if (!element) return false;
      const navbarHeight = window.innerWidth >= 768 ? 80 : 64;
      const top =
        element.getBoundingClientRect().top + window.scrollY - navbarHeight - 16;
      window.scrollTo({ top, behavior: "smooth" });
      return true;
    };

    // 描画が安定してからトップ→目的地へスムーズスクロール
    const raf = requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        scrollToTarget();
      });
    });

    return () => cancelAnimationFrame(raf);
  }, [hash]);
}